import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import { FakturacniProfil } from './fakturacniProfil';
import { NahradniSazbaPujcovna } from './nahradniSazbaPujcovna';
import Edit from './Edit.vue';
import List from './List.vue';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit }, CRUMB_LABEL_KEY),

	FakturacniProfil.router,
	NahradniSazbaPujcovna.router,
]);
